import * as React from 'react'

const SvgDashBoardProgressIcon = (props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="48"
      height="48"
      rx="10"
      fill="url(#paint0_linear_3997_87579)"
    />
    <path
      d="M30 32V22M24 32V16M18 32V26"
      stroke="#FFF9F5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3997_87579"
        x1="26.031"
        y1="1.2889e-06"
        x2="36.0006"
        y2="45.8313"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3F76FF" />
        <stop offset="1" stopColor="#444CE7" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgDashBoardProgressIcon
